import { render, staticRenderFns } from "./SelectPlan.vue?vue&type=template&id=236ad236&scoped=true"
import script from "./SelectPlan.vue?vue&type=script&lang=js"
export * from "./SelectPlan.vue?vue&type=script&lang=js"
import style0 from "./SelectPlan.vue?vue&type=style&index=0&id=236ad236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236ad236",
  null
  
)

export default component.exports